import waitTask from '@/common/utils/waitTask';
import threadRequests from '@/common/utils/threadRequests';

export default {
  FETCH_ITEMS({ dispatch, getters }) {
    return dispatch('locations/FETCH_LOCATIONS', undefined, { root: true })
      .then(() => getters.getItems);
  },
  // TODO: replace after api changes
  FETCH_ITEM({ dispatch }) {
    return dispatch('FETCH_ITEMS');
  },
  FETCH_NODES_WITH_NETWORKS({ dispatch }) {
    return dispatch('FETCH_ITEMS')
      .then(nodes => this.$takeFirst('rolesets/FETCH_NETWORK_ROLE_SETS', undefined).then(() => nodes))
      .then(nodes => threadRequests(nodes.map(node => () => dispatch('nodesInterfaces/FETCH_INTERFACES', node.id, { root: true }))));
  },
  FETCH_NODES_WITH_FC({ dispatch }) {
    return dispatch('FETCH_ITEMS')
      .then(() => dispatch('nodesFiberChannel/FETCH_FIBER_CHANNEL', undefined, { root: true }));
  },
  FORGET({ commit }, nodeId) {
    return this.$api.delete(`/api/v2/nodes/${nodeId}`)
      .then(waitTask)
      .then(() => {
        commit('locations/REMOVE_NODE', nodeId, { root: true });
      });
  },
  GET_OR_LOAD({ getters, dispatch }, { id }) {
    const node = getters.getItemById(id);
    if (node) {
      return Promise.resolve(node);
    }
    return dispatch('FETCH_ITEMS')
      .then(() => getters.getItemById(id))
      .catch((error) => {
        throw error;
      });
  }
};
